// extracted by mini-css-extract-plugin
module.exports = {"wave":"styles__wave___1t3WH","frontWave":"styles__frontWave___rR0oV"};